import { bindRemoteHandlers } from '../forms'
import waitUntilReady from '../waitUntilReady'
import intlTelInput from '../intl-tel-input/intlTelInput.js'
import jsFormFieldEventListener from '../utils/form_field'

import { getExampleNumber } from 'libphonenumber-js';
import { AsYouType, isPossiblePhoneNumber } from 'libphonenumber-js/min';
// eslint-disable-next-line import/extensions
import examples from 'libphonenumber-js/mobile/examples';


class PhoneCountryFieldValidation {
  constructor(phoneField, phoneValidatorField, phoneErrorField, iti) {
    this.phoneField = phoneField
    this.phoneValidatorField = phoneValidatorField
    this.phoneErrorField = phoneErrorField
    this.iti = iti
  }

  init() {
    this.initPlaceholder()
    this.initOnChangePlaceholder()
    this.initTypingFormatter()
    this.initValidCheck()
  }

  initPlaceholder() {
    const phoneNumberExampleFormat = getExampleNumber(
      this.countryCode(),
      examples
    )

    const phoneNumberPlaceholder = phoneNumberExampleFormat?.formatNational()
    const phoneNumberMaxLength = phoneNumberPlaceholder?.length || 15

    this.phoneField.value = ''
    this.phoneField.placeholder = phoneNumberPlaceholder
    this.phoneField.maxLength = phoneNumberMaxLength
  }

  initOnChangePlaceholder() {
    this.phoneField.addEventListener('countrychange', () => {
      this.initPlaceholder()
    })
  }

  initTypingFormatter() {
    this.phoneField.addEventListener('input', (event) => {
      let formatedNumber = this.formatNumberAsYouType(event.target.value)
      this.phoneField.value = formatedNumber
    })
  }

  initValidCheck() {
    this.phoneField.addEventListener('blur', () => {
      if(!this.isValid()) {
        this.addInvalidErrorMessage()
      }
    })
  }

  // Upgraded AsYouType formatter function to clean the input and address a minor bug in the formatter.
  formatNumberAsYouType = (number) => {
    try {
      this.clearErrorMessage()
      const countryCode = this.countryCode()
      // Clean the number up
      const clean = number.replace(/[^+0-9]/g, '')

      // Early return for US numbers with 3 or fewer digits.
      if (countryCode === 'US' && clean.length <= 3) {
        return clean;
      }

      // Using AsYouType formatter more effectively...
      const formatter = new AsYouType(countryCode);
      const result = [...clean].reduce((_, char) => formatter.input(char), '');

      return result
    } catch (e) {
      return number // Return the original number on error
    }
  }

  getNumber() {
    return this.iti.getNumber()
  }

  isValid() {
    return isPossiblePhoneNumber(this.iti.getNumber(), this.countryCode())
  }

  updateField() {
    this.phoneField.value = this.getNumber()
  }

  updatePhoneInvalidField(status) {
    this.phoneValidatorField.value = status
  }

  addInvalidErrorMessage() {
    this.phoneErrorField.textContent = 'Please enter a valid phone number'
    this.phoneErrorField.classList.remove('hidden')
  }

  clearErrorMessage() {
    this.phoneErrorField.textContent = ''
    this.phoneErrorField.classList.add('hidden')
  }

  countryCode() {
    return this.iti.getSelectedCountryData()?.iso2?.toUpperCase()
  }
}

waitUntilReady.then(() => {
  const formEl = document.getElementById('course-application-form');
  const loadingElement = formEl.parentElement.querySelector('.js-form-loading');
  const unexpectedErrorElement = formEl.parentElement.querySelector('.js-unexpected-error');

  if (!formEl?.length) {
    return;
  }

  try {
    const trackingJsonString = localStorage.getItem('gaTrackingParameters') || '{}';

    const hiddenInput = formEl.querySelector('input[type="hidden"][name$="[ga_tracking_parameters]"]');

    if (hiddenInput) {
      let trackingData = {};
      try {
        trackingData = JSON.parse(trackingJsonString);
        if (typeof trackingData !== 'object' || trackingData === null) {
          trackingData = {};
        }
      } catch (e) {
        console.error("Error parsing gaTrackingParameters for form:", e);
        trackingData = {};
      }

      hiddenInput.value = JSON.stringify(trackingData);

    } else {
      console.warn('GA Tracking hidden field not found in form.');
    }
  } catch (e) {
    console.error('Error processing GA tracking data for form:', e);
  }

  const phoneField = formEl.elements.course_application_form_phone
  const initialCountry = phoneField.dataset.countryFlag
  const phoneValidatorField = formEl.querySelector('[name="course_application_form\\[phone_invalid\\]"]')
  const phoneErrorField = formEl.querySelector(`[data-remote-message-key="phone"]`)

  const iti = intlTelInput(phoneField, {
    utilsScript: require('../intl-tel-input/utils.js'),
    initialCountry: initialCountry,
    showSelectedDialCode: true,
    nationalMode: false,
    autoPlaceholder: 'off',
    preferredCountries: ['au', 'bh', 'fr', 'sg', 'gb', 'us'],
    customContainer: 'w-full'
  });

  const phoneCountryFieldValidation = new PhoneCountryFieldValidation(phoneField,
    phoneValidatorField,
    phoneErrorField,
    iti)

  phoneCountryFieldValidation.init()

  bindRemoteHandlers(formEl);

  jsFormFieldEventListener(formEl)

  formEl.addEventListener('submit', (event) => {
    event.preventDefault()

    unexpectedErrorElement.classList.add('hidden');

    if(phoneCountryFieldValidation.isValid()) {
      phoneCountryFieldValidation.updatePhoneInvalidField(false)
      phoneCountryFieldValidation.updateField()
      loadingElement.classList.remove('hidden');
    } else {
      loadingElement.classList.add('hidden')
      phoneCountryFieldValidation.updatePhoneInvalidField(true)
      phoneCountryFieldValidation.addInvalidErrorMessage()
    }
  })

  formEl.addEventListener('ajax:success', async ({ detail: [data, _, xhr] }) => {
    if (xhr.status !== 201) {
      return;
    }

    const programName = window.dataLayer[0].programName
    const isBootcamp = window.dataLayer[0].programFormat === 'immersive'
    const programFormat = isBootcamp ? 'bootcamp' : 'short-course'

    let programSlug = document.getElementById('course_application_form_program_slug').value;
    if (programSlug === '') {
      const course = document.getElementById('course_application_form_program_id')
      programSlug = course.options[course.selectedIndex].getAttribute('data-program-slug');
    }

    window.dataLayer.push({
      "programSlug": programSlug
    });

    setTimeout(() => window.location = data.application.location, 1000);
  });

  formEl.addEventListener('ajax:error', async () => {
    loadingElement.classList.add('hidden');
    unexpectedErrorElement.classList.remove('hidden');
  });
});
